import { Dispatch } from "redux";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { createWorkflowTemplateRequest } from "@requests/management-console/create-workflow-template";
import { formatWorkflowTemplate } from "@formatters/workflow-templates/workflow-template-formatter";
import { resources } from "@constants/hardcoded-strings";
import { addWorkflowTemplate } from "@redux/actions/workflow-templates-actions";
import { WorkflowTemplateDetails } from "@idw-types/data/workflow-template-details";

export const createWorkflowTemplateReduxRequest = (dispatch: Dispatch) => async (
    workflowTemplate: Partial<WorkflowTemplateDetails>,
    axnCompanies: Array<AxnCompany>
) => {
    const { data, error, body } = await createWorkflowTemplateRequest(workflowTemplate);
    if (data?.response) {
        const formattedWorkflowTemplate = formatWorkflowTemplate(data.response, axnCompanies);
        dispatch(addWorkflowTemplate(formattedWorkflowTemplate));
        displaySuccessModal(
            dispatch,
            resources.requests.createWorkflowTemplate.success.title,
            resources.requests.createWorkflowTemplate.success.message
        );
        return data.response;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.createWorkflowTemplate.error.title,
            resources.requests.createWorkflowTemplate.error.message,
            null,
            null,
            body
        );
    }

    return null;
};